module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList11.2121f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList11.png
// module id = 2a09
// module chunks = 0